import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
// Pages
import { Home, Onboarding, Login, Register, Verify, Result } from '@pages';
// Components
import {
  AuthGuard,
  GuestGuard,
  VerifyGuard,
  useAuthContext,
} from '@components/auth';
import { Api, getToken } from './utils';

// Remove local storage values
localStorage.removeItem('logo');
localStorage.removeItem('profileLogo');

const App = () => {
  const { setUser, isAuthenticated, isInitialized } = useAuthContext();

  const favSrc = () => {
    if (import.meta.env.VITE_SITE === 'Paybilt') {
      return '/images/paybilt-favicon.png';
    } else {
      return '/images/payper-favicon.png';
    }
  };

  React.useEffect(() => {
    // get query string from url
    const queryString = window.location.search;

    // Check if query string contains hmac, code, host, shop
    if (
      queryString.includes('hmac') &&
      queryString.includes('code') &&
      queryString.includes('host') &&
      queryString.includes('shop')
    ) {
      // Save to localStorage
      localStorage.setItem('redirect', queryString);
    }
  }, []);

  // Remove redirect after 5 minutes
  React.useEffect(() => {
    const _r = async () => {
      const token = getToken();

      const { data } = await Api.put(
        '/profile',
        { redirect: '' },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (data.success) {
        localStorage.removeItem('redirect');
      }
    };

    const timer = setTimeout(() => {
      _r();
    }, 10 * 60 * 1000); // 10 minutes

    return () => clearTimeout(timer);
  }, []);

  React.useEffect(() => {
    const _getUser = async () => {
      const token = getToken();
      if (token) {
        try {
          const { data } = await Api.get('/profile', {
            headers: { Authorization: `Bearer ${token}` },
          });
          setUser(data.data.user);
        } catch (error) {
          setUser({});
        }
      }
    };

    if (isAuthenticated) _getUser();
  }, [isAuthenticated]);

  React.useEffect(() => {
    saveRedirect();
  }, []);

  const saveRedirect = async () => {
    const token = getToken();

    // get query string from url
    const queryString = window.location.search;

    // Check if query string contains hmac, code, host, shop
    if (
      queryString.includes('hmac') &&
      queryString.includes('code') &&
      queryString.includes('host') &&
      queryString.includes('shop')
    ) {
      // save to db
      const { data } = await Api.put(
        '/profile',
        { redirect: queryString },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (data.success) {
        // Save to localStorage
        localStorage.setItem('redirect', queryString);
      }
    }
  };

  return (
    <>
      <Helmet>
        <link rel="shortcut icon" type="image/jpg" href={favSrc()} />
      </Helmet>

      <Routes>
        <Route
          path="/"
          element={
            <AuthGuard>
              <Home />
            </AuthGuard>
          }
        />
        <Route
          path="/login"
          element={
            <GuestGuard>
              <Login />
            </GuestGuard>
          }
        />
        <Route
          path="/register"
          element={
            <GuestGuard>
              <Register />
            </GuestGuard>
          }
        />
        <Route path="/verify" element={<Verify />} />
        <Route
          path="/onboarding"
          element={
            <AuthGuard>
              <VerifyGuard>
                <Onboarding />
              </VerifyGuard>
            </AuthGuard>
          }
        />
        <Route
          path="/onboarding/completed"
          element={
            <AuthGuard>
              <VerifyGuard>
                <Result />
              </VerifyGuard>
            </AuthGuard>
          }
        />
      </Routes>
    </>
  );
};

export default App;
